import React from "react";
import PageContent from "../components/PageContent";

export default function About() {
    return (
        <PageContent
            internalId="about_us"
            fallbackTitle="О нас"
            fallbackContent="<p>Статический блок с информацией.</p>"
        />
    );
}
